export default __webpack_public_path__ + "static/media/Caritas_int_be_blanc_seul@2x.bd1aacda.png";